import styled from 'styled-components';

export const TooltipContainer = styled.span`
  margin-left: ${({ theme }) => theme.token.marginXXS}px;
`;
